import { clientApp } from './index';

export const importTransactions = (date: string) => clientApp.get(`/ui/gastrofix/import/transactions?date=${date}`);

export const getArticleFamilies = (id: string) => clientApp.get(`/ui/gastrofix/article_families/${id}`);

export const getAccounts = () => clientApp.get(`/ui/gastrofix/settings/account`);

export const deleteConfig = (id: string) => clientApp.delete(`/ui/gastrofix/${id}`);
